import { Subscription } from "rxjs";
import { CommonService } from "src/app/service/common.service";
import { ExpiryMasterDateDef } from "./expiry-master-rec";
import { FormControl } from "@angular/forms";
import { ExpiryItemDateDto, ExpiryItemDto, ReqSaveExpiry, RspGetExpiryItemByJan, RspSaveExpiry, UpdateExpiryAlertDto, UpdateItemDateDto } from "src/app/webservice/item-expiry";
import { HttpBasicService } from "src/app/service/http-basic.service";
import { OrderGroupDto } from "src/app/webservice/order-group";

export interface ExpiryDateActionEdit {
  storeCd:            string;
  itemCd:             string;
  groupId:            number;
  groupUsrCd:         string;
  itemDate:           string;
  alertType:          number;
  alertRank:          number;
  alertStartDate:     string;
  alertMsg:           string;
  isSoldOut:          boolean;
  isCompleted:        boolean;
  isDirty:            boolean;
  isNew:              boolean;
  isDeleted:          boolean;
  formResult:         FormControl;
  formPrintCount:     FormControl;
}

export interface ExpiryItemDate {
  storeCd:          string;
  itemCd:           string;
  groupUsrCd:       string;
  itemDate:         Date;
  alertStartDates:  Date[];
  isCompleted:      number[];
  isSoldOut:        boolean;
  soldOutDate:      Date;
  soldOutDateStr:   string;
}

export interface ExpiryGroup {
  groupId: number;
  groupUsrCd: string;
  groupName: string;
  beginDate: string;
  endDate: string;
  sortKey: string;
  expiryItemDate: ExpiryItemDate[];
  edit?: {
    isDirty:  boolean;
    dateActions: ExpiryDateActionEdit[];
  }
}

export interface AlertForAll {
  alertMsg:   string;
  alertRank:  number;
}

export class ExpiryItemRec {

  public storeCd: string                = "";
  public itemCd: string                 = "";
  public itemName: string               = "";
  public itemStandard: string           = "";
  public price: number                  = 0;
  public tax: number                    = 8;
  public expiryType: number             = 1;
  public discountType: number           = 1;
  public dateDef: ExpiryMasterDateDef[] = [];
  public groupList: ExpiryGroup[]       = [];
  public targetGroup: ExpiryGroup;
  public dateActionAll: AlertForAll[];
  public targetDate: Date;
  public targetDateStr: string;
  public isDirty: boolean               = false;
  public initUpdateList: ExpiryItemDate[] = [];
  public today: Date;

  public subsc: Subscription[] = [];
  public changeListener: (mode: boolean)=>void;

  constructor(
    public commonService: CommonService,
    public httpBasic: HttpBasicService) {
    this.today = this.commonService.getToday();
    this.targetDate = this.commonService.copyDate(this.today);
    this.targetDateStr = this.commonService.formatDate(this.targetDate);
  }

  initByDto(item: ExpiryItemDto, groups: OrderGroupDto[], itemDates: ExpiryItemDateDto[], targetGroupUsrCd: string) {
    let masterChanged: boolean = false;

    // let dto = response.item;
    let dto = item;
    this.storeCd = dto.storeCd;
    this.itemCd = dto.itemCd;
    this.itemName = dto.itemName;
    this.itemStandard = dto.itemStandard;
    this.price = dto.price;
    this.tax = dto.tax;
    this.expiryType = dto.expiryType;
    this.discountType = dto.discountType;
    this.dateDef = [];
    if (dto.datesToExpiry0 != -1) this.dateDef.push({datesToExpiry: dto.datesToExpiry0, action: dto.action0, discount: dto.discount0});
    if (dto.datesToExpiry1 != -1) this.dateDef.push({datesToExpiry: dto.datesToExpiry1, action: dto.action1, discount: dto.discount1});
    if (dto.datesToExpiry2 != -1) this.dateDef.push({datesToExpiry: dto.datesToExpiry2, action: dto.action2, discount: dto.discount2});
    if (dto.datesToExpiry3 != -1) this.dateDef.push({datesToExpiry: dto.datesToExpiry3, action: dto.action3, discount: dto.discount3});
    if (dto.datesToExpiry4 != -1) this.dateDef.push({datesToExpiry: dto.datesToExpiry4, action: dto.action4, discount: dto.discount4});

    this.groupList = [];
    for (let i = 0; i < groups.length; i++) {
      let dto = groups[i];
      this.groupList.push({
        groupId: dto.orderGroupId,
        groupUsrCd: dto.orderGroupUsrCd,
        groupName: dto.orderGroupName,
        beginDate: dto.beginDate,
        endDate: dto.endDate,
        sortKey: "",
        expiryItemDate: []
      });
    }
    this.targetGroup = this.groupList.find((rec) => rec.groupUsrCd === targetGroupUsrCd);

    for (let i = 0; i < itemDates.length; i++) {
      let dto = itemDates[i];
      let group: ExpiryGroup = this.groupList.find((item) => item.groupId === dto.groupId);
      if (!group) continue;       // oops
      let itemDate: ExpiryItemDate = {
        storeCd:          this.storeCd,
        itemCd:           this.itemCd,
        groupUsrCd:       dto.groupUsrCd,
        itemDate:         this.commonService.getDate(dto.itemDate),
        alertStartDates:  [],
        isCompleted:      [],
        isSoldOut:        dto.isSoldOut,
        soldOutDate:      dto.soldOutDate !== "" ? this.commonService.getDate(dto.soldOutDate) : undefined,
        soldOutDateStr:   dto.soldOutDate !== "" ? dto.soldOutDate : undefined
      }
      let itemDateCheck: ExpiryItemDate = {...itemDate};
      if (dto.alertStartDate1 !== "") {
        itemDate.alertStartDates.push(this.commonService.getDate(dto.alertStartDate1));
        itemDate.isCompleted.push(dto.isCompleted1);
      }
      if (dto.alertStartDate2 !== "") {
        itemDate.alertStartDates.push(this.commonService.getDate(dto.alertStartDate2));
        itemDate.isCompleted.push(dto.isCompleted2);
      }
      if (dto.alertStartDate3 !== "") {
        itemDate.alertStartDates.push(this.commonService.getDate(dto.alertStartDate3));
        itemDate.isCompleted.push(dto.isCompleted3);
      }
      if (dto.alertStartDate4 !== "") {
        itemDate.alertStartDates.push(this.commonService.getDate(dto.alertStartDate4));
        itemDate.isCompleted.push(dto.isCompleted4);
      }
      if (dto.alertStartDate5 !== "") {
        itemDate.alertStartDates.push(this.commonService.getDate(dto.alertStartDate5));
        itemDate.isCompleted.push(dto.isCompleted5);
      }
      for (let i = 0; i < this.dateDef.length; i++) {
        let d = this.commonService.getDate(dto.itemDate);
        if (this.expiryType === 1) {
          d.setDate(d.getDate() - this.dateDef[i].datesToExpiry);
        } else {
          d.setDate(d.getDate() + this.dateDef[i].datesToExpiry);
        }
        itemDateCheck.alertStartDates.push(d);
        if (i >= itemDate.alertStartDates.length ||
            itemDate.alertStartDates[i].getTime() !== itemDateCheck.alertStartDates[i].getTime()) {
          masterChanged = true;
        }
        if (dto.isSoldOut) {
          itemDateCheck.isCompleted.push(1);
        } else {
          if (masterChanged) {
            if (d.getTime() <= this.today.getTime()) {
              itemDateCheck.isCompleted.push(0);
            } else {
              itemDateCheck.isCompleted.push(-1);
            }
          } else {
            itemDateCheck.isCompleted.push(itemDate.isCompleted[i]);
          }
        }
      }
      if (masterChanged) {
        group.expiryItemDate.push(itemDateCheck);
        this.initUpdateList.push(itemDateCheck);
      } else {
        group.expiryItemDate.push(itemDate);
      }
    }

    for (let i = 0; i < this.groupList.length; i++) {
      let group = this.groupList[i];
      group.expiryItemDate.sort((a, b) => {
        if (a.itemDate < b.itemDate) return -1;
        if (a.itemDate > b.itemDate) return 1;
        return 0;
      });
    }

    // rec.setTargetDate(this.kijyunDate);
    this.setAction(true);
    this.prepareEdit();
    if (masterChanged) this.initAlertUpdate();
  }

  setTargetDate(target: Date) {
    if (!target) {
      this.targetDate = this.commonService.copyDate(this.today);
      this.targetDateStr = this.commonService.formatDate(this.targetDate);
    } else {
      this.targetDate = this.commonService.copyDate(target);
      this.targetDateStr = this.commonService.formatDate(this.targetDate);
    }
  }

  setListner(func:(mode: boolean)=>void) {
    this.changeListener = func;
  }

  setAction(initial?: boolean) {
    this.dateActionAll = [];
    if (!this.dateDef || this.dateDef.length === 0) {
      if (!this.dateActionAll.find((rec) => rec.alertRank === -4)) {
        this.dateActionAll.push({
          alertMsg:   this.getAlertMsg(-4),
          alertRank:  -4
        });
      }
    }
    for (let group = 0; group < this.groupList.length; group++) {
      if (!this.groupList[group].expiryItemDate || this.groupList[group].expiryItemDate.length === 0) {
        this.dateActionAll.push({
          alertMsg:   this.getAlertMsg(-3) + "(" + this.groupList[group].groupUsrCd + ")",
          alertRank:  -3
        });
        continue;
      }
      for (let i = 0; i < this.groupList[group].expiryItemDate.length; i++) {
        let itemDate = this.groupList[group].expiryItemDate[i];
        let rank = this.getAlertRank(itemDate);
        if (rank > 0) {
          if (!this.dateActionAll.find((rec) => rec.alertRank === rank)) {
            this.dateActionAll.push({
              alertMsg:   this.dateDef[rank - 1].action,
              alertRank:  rank
            });
          }
        }/* else if (rank === -2) {
          if (!this.dateActionAll.find((rec) => rec.alertRank === rank)) {
            this.dateActionAll.push({
              alertMsg:   this.getAlertMsg(-2),
              alertRank:  rank
            });
          }
        }*/
      }
    }
    this.dateActionAll.sort((a, b) => {
      if (a.alertRank < b.alertRank) return -1;
      if (a.alertRank === b.alertRank) return 0;
      return 1;
    });
  }

  setActionAll() {
    this.setAction();
  }

  getAlertMsg(rank: number): string {
    if (rank === -4) return "期限ルール未登録";
    if (rank === -3) return "未登録";
    if (rank === -2) return "期限越え";
    if (rank === 0) return "対応不要";
    if (rank - 1 >= this.dateDef.length) return "";
    return this.dateDef[rank - 1].action;
  }

  prepareEdit() {
    this.groupList.forEach((group) => {
      if (!group.edit) {
        group.edit = {
          isDirty: false,
          dateActions: []
        };
        group.expiryItemDate.forEach((rec) => {
          let rank = this.getAlertRank(rec);
          let result: number = 0;
          if (rec.isSoldOut) {
            result = 2;
          } else if (rank <= 0) {
            result = 0;
          } else if (rec.isCompleted[rank - 1] === 1) {
            result = 1;
          } else {
            result = 0;
          }
          let dateAction: ExpiryDateActionEdit = {
            storeCd:        this.storeCd,
            itemCd:         this.itemCd,
            groupId:        group.groupId,
            groupUsrCd:     group.groupUsrCd,
            itemDate:       this.commonService.formatDate(rec.itemDate),
            alertType:      1,
            alertRank:      rank,
            alertStartDate: rank > 0 ? this.commonService.formatDate(rec.alertStartDates[rank - 1]) : "",
            alertMsg:       this.getAlertMsg(rank),
            isSoldOut:      rec.isSoldOut,
            isCompleted:    rank > 0 && rec.isCompleted[rank - 1] === 1 ? true : false,
            isDirty:        false,
            isNew:          false,
            isDeleted:      false,
            formResult:     new FormControl("" + result),
            formPrintCount: new FormControl(1)
          };
          group.edit.dateActions.push(dateAction);
          this.subsc.push(dateAction.formResult.valueChanges.subscribe((val) => {
            this.setDirty(dateAction);
          }));
        });
      }
    });
  }

  setResult(dateAction: ExpiryDateActionEdit, val: number) {
    if (dateAction.formResult.disabled) return;
    dateAction.formResult.setValue("" + val);
  }

  endEdit() {
    this.cleanupEdit();
  }

  cancelEdit() {
    this.cleanupEdit();
    this.prepareEdit();
  }

  saveEdit(commitListener?: ()=>void) {
    let request: ReqSaveExpiry = {
      access: this.commonService.loginUser,
      dates: this.getUpdateDateList(),
      // alerts: this.getUpdateAlertList(),
      alerts: [],
      expiryGroupLabel: this.commonService.literal["itemExpiryGroup"]
    };

    let ref = this.commonService.openSpinnerForSubComp(this.commonService.pageTitle, "登録中・・・");
    let subsc = this.httpBasic.generalRequest("SaveExpiry", request).subscribe(
      (response: RspSaveExpiry) => {
        this.commonService.closeSpinnerForSubComp(ref);
        subsc.unsubscribe();
        this.receiveSaveEdit(response, commitListener);
      },
      (error) => {
        this.commonService.closeSpinnerForSubComp(ref);
        subsc.unsubscribe();
        this.httpBasic.handleError(error);
      }
    );
  }

  receiveSaveEdit(response: RspSaveExpiry, commitListener?: ()=>void) {
    if (this.httpBasic.handleAppError(response)) return;

    this.commitEdit();
    if (commitListener) commitListener();
  }

  ExpiryItemDateToDto(itemDate: ExpiryItemDate): ExpiryItemDateDto {
    let dto: ExpiryItemDateDto = {
      storeCd:          this.storeCd,
      itemCd:           this.itemCd,
      groupId:          this.targetGroup.groupId,
      groupUsrCd:       this.targetGroup.groupUsrCd,
      itemDate:         this.commonService.formatDate(itemDate.itemDate),
      alertStartDate1:  this.saveAlertStartDate(itemDate, 0),
      alertStartDate2:  this.saveAlertStartDate(itemDate, 1),
      alertStartDate3:  this.saveAlertStartDate(itemDate, 2),
      alertStartDate4:  this.saveAlertStartDate(itemDate, 3),
      alertStartDate5:  this.saveAlertStartDate(itemDate, 4),
      isCompleted1:     this.saveIsCompleted(itemDate, 0),
      isCompleted2:     this.saveIsCompleted(itemDate, 1),
      isCompleted3:     this.saveIsCompleted(itemDate, 2),
      isCompleted4:     this.saveIsCompleted(itemDate, 3),
      isCompleted5:     this.saveIsCompleted(itemDate, 4),
      isSoldOut:        itemDate.isSoldOut,
      soldOutDate:      (itemDate.soldOutDate !== undefined) ? this.commonService.formatDate(itemDate.soldOutDate) : ""
    }
    return dto;
  }

  dateActionToExpiryItemDate(dateAction: ExpiryDateActionEdit, itemDate: ExpiryItemDate) {
    if (dateAction.itemDate !== this.commonService.formatDate(itemDate.itemDate)) return;
    if (dateAction.alertRank === -3) return;

    for (let i = itemDate.isCompleted.length; i < itemDate.alertStartDates.length; i++) {
      if (this.today < itemDate.alertStartDates[i]) {
        itemDate.isCompleted.push(-1);
      } else {
        itemDate.isCompleted.push(0);
      }
    }
    let result = parseInt(dateAction.formResult.value);
    if (result === 2) {
      if (!itemDate.isSoldOut) {
        itemDate.isSoldOut = true;
        itemDate.soldOutDate = this.today;
        itemDate.soldOutDateStr = this.commonService.formatDate(this.today);
      }
      itemDate.isCompleted.forEach((isCompleted) => isCompleted = 1);
    } else if (dateAction.alertRank > 0) {
      itemDate.isCompleted[dateAction.alertRank - 1] = result;
      itemDate.isSoldOut = false;
      itemDate.soldOutDate = undefined;
      itemDate.soldOutDateStr = "";
    }
    for (let i = 0; i < itemDate.isCompleted.length - 1; i++) {
      if (itemDate.isCompleted[i] === 1) itemDate.isCompleted[i + 1] = 1;
    }
  }

  dateActionToNewExpiryItemDate(dateAction: ExpiryDateActionEdit): ExpiryItemDate {
    let rec: ExpiryItemDate = {
      storeCd:          this.storeCd,
      itemCd:           this.itemCd,
      groupUsrCd:       dateAction.groupUsrCd,
      itemDate:         this.commonService.getDate(dateAction.itemDate),
      alertStartDates:  [],
      isCompleted:      [],
      isSoldOut:        dateAction.isSoldOut,
      soldOutDate:      dateAction.isSoldOut ? this.today : undefined,
      soldOutDateStr:   dateAction.isSoldOut ? this.commonService.formatDate(this.today) : undefined,
    };
    for (let i = 0; i < this.dateDef.length; i++) {
      let d = this.commonService.getDate(dateAction.itemDate);
      if (this.expiryType === 1) {
        d.setDate(d.getDate() - this.dateDef[i].datesToExpiry);
      } else {
        d.setDate(d.getDate() + this.dateDef[i].datesToExpiry);
      }
      rec.alertStartDates.push(d);
    }
    this.dateActionToExpiryItemDate(dateAction, rec);

    return rec;
  }

  commitEdit() {
    let newList: ExpiryItemDate[] = [];

    for (let i = this.targetGroup.edit.dateActions.length - 1; i >= 0 ; i--) {
      let dateAction = this.targetGroup.edit.dateActions[i];
      if (!dateAction.isDirty) continue;
      if (dateAction.isDeleted) {
        let index = this.targetGroup.expiryItemDate.findIndex((rec) => this.commonService.formatDate(rec.itemDate) === dateAction.itemDate);
        if (index >= 0) this.targetGroup.expiryItemDate.splice(index, 1);
        this.targetGroup.edit.dateActions.splice(i, 1);
        continue;
      }
      let itemDate = this.targetGroup.expiryItemDate.find((rec) => this.commonService.formatDate(rec.itemDate) === dateAction.itemDate);
      if (!itemDate) {
        dateAction.isDirty = false;
        dateAction.isNew = false;
        let rec = this.dateActionToNewExpiryItemDate(dateAction);
        this.targetGroup.expiryItemDate.push(rec);
        newList.push(rec);
      } else {
        this.dateActionToExpiryItemDate(dateAction, itemDate);
      }
    }
    this.targetGroup.edit.isDirty = false;
    this.isDirty = false;
    /*
    this.targetGroup.expiryItemDate.sort((a, b) => {
      if (a.itemDate < b.itemDate) return -1;
      if (a.itemDate > b.itemDate) return 1;
      return 0;
    });
    */

    for (let i = 0; i < newList.length; i++) {
      // let itemDate = newList[i];
      let itemDateBase: ExpiryItemDate = {
        ...newList[i]
      };
      itemDateBase.isCompleted.forEach((comp) => {
        if (comp !== -1) comp = -0;
      });
      itemDateBase.isSoldOut = false;
      itemDateBase.soldOutDate = undefined;
      itemDateBase.soldOutDateStr = "";
      for (let j = 0; j < this.groupList.length; j++) {
        let group = this.groupList[j];
        if (group.groupUsrCd === this.targetGroup.groupUsrCd) continue;
        if (group.expiryItemDate.find((rec) => rec.itemDate.getTime() === itemDateBase.itemDate.getTime())) continue;
        let itemDate: ExpiryItemDate = {
          ...itemDateBase
        };
        itemDate.groupUsrCd = group.groupUsrCd;
        group.expiryItemDate.push(itemDate);
      }
    }
    for (let i = 0; i < this.groupList.length; i++) {
      let group = this.groupList[i];
      group.expiryItemDate.sort((a, b) => {
        if (a.itemDate < b.itemDate) return -1;
        if (a.itemDate > b.itemDate) return 1;
        return 0;
      });
    }

    this.setActionAll();
    if (this.changeListener) this.changeListener(false);
  }

  cleanupEdit() {
    this.subsc.forEach((subsc) => {subsc.unsubscribe();});
    this.subsc = [];

    this.groupList.forEach((group) => {
      if (group.edit) delete group.edit;
      // group.dateActions.forEach((action) => action.isDeleted = false);
    });
    if (this.isDirty) {
      this.isDirty = false;
      if (this.changeListener) this.changeListener(false);
    }
  }

  getAlertRank(itemDate: ExpiryItemDate) {
    if (!this.dateDef || this.dateDef.length === 0) return -4;
    // if (this.expiryType === 1 && this.targetDate.getTime() > itemDate.itemDate.getTime()) return -2;
    for (let i = 0; i < itemDate.alertStartDates.length; i++) {
      if (this.targetDate.getTime() >= itemDate.alertStartDates[i].getTime()) return i + 1;
    }
    return 0;
  }

  getAlertRankByDate(itemDate: Date): number {
    if (this.dateDef.length == 0) return -4;
    if (!itemDate) return -1;
    if (this.expiryType === 1 && this.targetDate.getTime() > itemDate.getTime()) return -2;
    let def: ExpiryMasterDateDef = undefined;
    for (let i = 0; i < this.dateDef.length; i++) {
      def = this.dateDef[i];
      let d = this.commonService.copyDate(itemDate);
      if (this.expiryType === 1) {
        d.setDate(d.getDate() - def.datesToExpiry);
      } else {
        d.setDate(d.getDate() + def.datesToExpiry);
      }
      if (this.targetDate >= d) {
        return i + 1;
      }
    }
    return 0;
  }

  findDefDate(expiryDate: Date): ExpiryMasterDateDef {
    if (this.dateDef.length == 0) return undefined;
    let def: ExpiryMasterDateDef = undefined;
    for (let i = 0; i < this.dateDef.length; i++) {
      def = this.dateDef[i];
      let d = this.commonService.copyDate(expiryDate);
      if (this.expiryType === 1) {
        d.setDate(d.getDate() - def.datesToExpiry);
      } else {
        d.setDate(d.getDate() + def.datesToExpiry);
      }
      if (this.targetDate >= d) return def;
    }
    return undefined;
  }

  getDefDate(expiryDate: Date): Date {
    if (!expiryDate) return null;
    let def = this.findDefDate(expiryDate);
    if (!def) return null;
    let d = this.commonService.copyDate(expiryDate);
    if (this.expiryType === 1) {
      d.setDate(d.getDate() - def.datesToExpiry);
    } else {
      d.setDate(d.getDate() + def.datesToExpiry);
    }
    return d;
  }

  getColorDateAction(rec: AlertForAll) {
    let base = {"font-weight": "bold", "font-size" : "1.2rem", "padding": "3px"};
    let white = {"color": "black", "background-color": "white", ...base};
    let red = {"color": "red", "background-color": "#FBE5D6", "border" : "solid 2px red", ...base};

    if (this.dateDef.length == 0) return red;
    let index = rec.alertRank;
    if (index < -1) return red;
    if (index <= 0) return white;
    index--;
    if (index < this.commonService.config.itemExpiry.colors.length) {
      return {
        "color": this.commonService.config.itemExpiry.colors[index].fg,
        "background-color": this.commonService.config.itemExpiry.colors[index].bg,
        "border" : "solid 2px " + this.commonService.config.itemExpiry.colors[index].fg,
        ...base
      };
    }
    return {};
  }

/*
  getDefActionStr(expiryDate: Date): string {
    if (!expiryDate) return "";
    let def = this.findDefDate(expiryDate);
    if (!def) return "";
    return def.action;
  }
*/

  hasExpiryDate() {
    for (let i = 0; i < this.groupList.length; i++) {
      let group = this.groupList[i];
      if (!group.expiryItemDate) continue;
      if (group.expiryItemDate.length > 0) return true;
    }
    return false;
  }

  setSoldOut() {
    this.targetGroup.edit.dateActions.forEach((rec) => {
      rec.formResult.setValue("2");
    });
  }

  getEditAlertStartDate(itemDate: string, rank: number) {
    let d = this.commonService.getDate(itemDate);
    if (0 < rank && rank <= this.dateDef.length) {
      if (this.expiryType === 1) {
        d.setDate(d.getDate() - this.dateDef[rank - 1].datesToExpiry);
      } else {
        d.setDate(d.getDate() + this.dateDef[rank - 1].datesToExpiry);
      }
      return this.commonService.formatDate(d);
    }
    return "";
  }

  addDate(itemDate: string) {
    let dateAction: ExpiryDateActionEdit = this.targetGroup.edit.dateActions.find((rec) => rec.itemDate === itemDate);
    if (dateAction) {
      if (dateAction.isDeleted) {
        dateAction.isDeleted = false;
        dateAction.formResult.setValue("0");
        this.setDirty(dateAction);
        return true;
      }
     return false;
    }

    let rank = this.getAlertRankByDate(this.commonService.getDate(itemDate));
    dateAction = {
      storeCd: this.storeCd,
      itemCd: this.itemCd,
      groupId: this.targetGroup.groupId,
      groupUsrCd: this.targetGroup.groupUsrCd,
      itemDate: itemDate,
      alertType: 1,
      alertRank: rank,
      alertStartDate: this.getEditAlertStartDate(itemDate, rank),
      alertMsg: this.getAlertMsg(rank),
      isCompleted: false,
      isSoldOut: false,
      isDirty: true,
      isNew: true,
      isDeleted: false,
      formResult: new FormControl("0"),
      formPrintCount: new FormControl(1)
    }
    this.subsc.push(dateAction.formResult.valueChanges.subscribe((val) => {
      this.setDirty(dateAction);
    }));

    this.targetGroup.edit.dateActions.push(dateAction);
    this.targetGroup.edit.dateActions.sort((a, b)=> {
      if (a.itemDate < b.itemDate) return -1;
      if (a.itemDate > b.itemDate) return 1;
      return 0;
    });
    this.setDirty(dateAction);
    return true;
  }

  resetDates() {
    this.targetGroup.edit.dateActions.forEach((rec) => {
      rec.isDeleted = true;
      this.setDirty(rec);
    });
  }

  dirty() {
    return this.isDirty;
  }

  setDirty(dateAction: ExpiryDateActionEdit) {
    dateAction.isDirty = true;
    this.targetGroup.edit.isDirty = true;
    this.isDirty = true;
    if (this.changeListener) this.changeListener(true);
  }

  getUpdateDateList(): UpdateItemDateDto[] {
    let list: UpdateItemDateDto[] = [];
    let newList: ExpiryItemDate[] = [];

    for (let i = 0; i < this.targetGroup.edit.dateActions.length; i++) {
      let dateAction = this.targetGroup.edit.dateActions[i];

      if (!dateAction.isDirty) continue;
      let itemDate = this.targetGroup.expiryItemDate.find((rec) => this.commonService.formatDate(rec.itemDate) === dateAction.itemDate);
      let mode = "update";
      if (dateAction.isDeleted) {
        if (!itemDate) continue;
        mode = "del";
      }

      let rec: ExpiryItemDate;
      if (!itemDate) {
        rec = this.dateActionToNewExpiryItemDate(dateAction);
        newList.push(rec);
      } else {
        rec = {
          storeCd:          itemDate.storeCd,
          itemCd:           itemDate.itemCd,
          groupUsrCd:       itemDate.groupUsrCd,
          itemDate:         itemDate.itemDate,
          alertStartDates:  [...itemDate.alertStartDates],
          isCompleted:      [...itemDate.isCompleted],
          isSoldOut:        itemDate.isSoldOut,
          soldOutDate:      itemDate.soldOutDate,
          soldOutDateStr:   itemDate.soldOutDateStr
        }
        this.dateActionToExpiryItemDate(dateAction, rec);
      }

      list.push({
        mode: mode,
        ...this.ExpiryItemDateToDto(rec)
      });

      /* TODO */
      for (let i = 0; i < newList.length; i++) {
        let itemDate = newList[i];
        let dtoBase: UpdateItemDateDto = {
          mode: "update",
          ...this.ExpiryItemDateToDto(itemDate)
        };
        if (dtoBase.isCompleted1 !== -1) dtoBase.isCompleted1 = 0;
        if (dtoBase.isCompleted2 !== -1) dtoBase.isCompleted2 = 0;
        if (dtoBase.isCompleted3 !== -1) dtoBase.isCompleted3 = 0;
        if (dtoBase.isCompleted4 !== -1) dtoBase.isCompleted4 = 0;
        if (dtoBase.isCompleted5 !== -1) dtoBase.isCompleted5 = 0;
        dtoBase.isSoldOut = false;
        dtoBase.soldOutDate = "";

        for (let j = 0; j < this.groupList.length; j++) {
          let group = this.groupList[j];
          if (group.groupUsrCd === this.targetGroup.groupUsrCd) continue;
          if (group.expiryItemDate.find((rec) => rec.itemDate.getTime() === itemDate.itemDate.getTime())) continue;
          let dto: UpdateItemDateDto = {
            ...dtoBase
          };
          dto.groupId = group.groupId;
          dto.groupUsrCd = group.groupUsrCd;
          list.push(dto);
        }
      }
    }

    return list;
  }

  /*
  getUpdateAlertList(): UpdateExpiryAlertDto[] {
    let list: UpdateExpiryAlertDto[] = [];

    for (let i = 0; i < this.targetGroup.edit.dateActions.length; i++) {
      let dateAction = this.targetGroup.edit.dateActions[i];

      if (!dateAction.isDirty) continue;
      let mode = "update";
      if (dateAction.isDeleted) {
        if (dateAction.isNew) continue;
        mode = "del";
      }
      let isCompleted = false;
      let isSoldOutDate = false;
      let isSoldOutItem = false;
      let val = dateAction.formResult.value;
      switch(val) {
        case "0": {
          break;
        }
        case "1": {
          isCompleted = true;
          break;
        }
        case "2": {
          isCompleted = true;
          isSoldOutDate = true;
          break;
        }
        case "3": {
          isCompleted = true;
          isSoldOutDate = true;
          isSoldOutItem = true;
          break;
        }
      }
      list.push({
        mode: mode,
        storeCd:        this.storeCd,
        itemCd:         this.itemCd,
        itemName:       "",
        itemStandard:   "",
        itemSalesPrice: 0,
        itemTax:        0,
        groupId:        this.targetGroup.groupId,
        groupUsrCd:     this.targetGroup.groupUsrCd,
        groupName:      "",
        alertType:      1,
        itemDate:       dateAction.itemDate,
        alertRank:      dateAction.alertRank,
        alertStartDate: dateAction.alertStartDate,
        alertMsg:       dateAction.alertMsg,
        isCompleted:    isCompleted,
        isSoldOutDate:  isSoldOutDate,
        isSoldOutItem:  isSoldOutItem,
        expiryType:     this.expiryType,
        discountType:   this.discountType
      });
    }

    return list;
  }
  */

  saveAlertStartDate(itemDate: ExpiryItemDate, index: number): string {
    if (index < itemDate.alertStartDates.length) return this.commonService.formatDate(itemDate.alertStartDates[index]);
    return "";
  }

  saveIsCompleted(itemDate: ExpiryItemDate, index: number): number {
    if (itemDate.isCompleted.length > 0) return itemDate.isCompleted[index];
    return -1;
  }

  initAlertUpdate() {
    let list: UpdateItemDateDto[] = [];

    for (let i = 0; i < this.initUpdateList.length; i++) {
      let itemDate = this.initUpdateList[i];
      list.push({
        mode: "update",
        ...this.ExpiryItemDateToDto(itemDate)
      });
    }

    let request: ReqSaveExpiry = {
      access: this.commonService.loginUser,
      dates: list,
      alerts: [],
      expiryGroupLabel: this.commonService.literal["itemExpiryGroup"]
    };

    let ref = this.commonService.openSpinnerForSubComp(this.commonService.pageTitle, "登録中・・・");
    let subsc = this.httpBasic.generalRequest("SaveExpiry", request).subscribe(
      (response: RspSaveExpiry) => {
        this.commonService.closeSpinnerForSubComp(ref);
        subsc.unsubscribe();
        if (this.httpBasic.handleAppError(response)) return;
      },
      (error) => {
        this.commonService.closeSpinnerForSubComp(ref);
        subsc.unsubscribe();
        this.httpBasic.handleError(error);
      }
    );
  }
}
